module.exports = __webpack_public_path__ + "img/msu3-1.00dbeb5e.png";